import {
  MdPeople,
  MdLock,
  MdAccountCircle,
  MdFolderSpecial,
  MdErrorOutline,
  MdList,
} from "react-icons/md";
import { RiFolderOpenFill } from "react-icons/ri";

export interface NavigationInterfece {
  title: string;
  url: string;
}

export interface SideNavigationInterfece {
  title: string;
  url: string;
  icon: any;
  label: string;
}

/**
 * @description Appear allways
 * @done_by Emma
 */
export const PUBLIC: NavigationInterfece[] = [
  // {
  //   title: "Home",
  //   url: "/",
  // },
];

/**
 * @description Appear once the user is not logged in
 * @done_by Emma
 */
export const NON_AUTHENTICATED: NavigationInterfece[] = [
  // {
  //   title: "Login",
  //   url: "/login",
  // },
];

/**
 * @description Appear once the user is logged in
 * @done_by Emma
 */
export const AUTHENTICATED: SideNavigationInterfece[] = [
  {
    icon: MdAccountCircle,
    title: "Profile details",
    label: "Profile",
    url: "/profile",
  },

  // {
  //   icon: MdFolderSpecial,
  //   title: "Applications",
  //   label: "Applic,",
  //   url: "/applications",
  // },
  // {
  //   icon: MdErrorOutline,
  //   title: "Claims",
  //   label: "Claims",
  //   url: "/apply",
  // },
  {
    icon: MdLock,
    title: "User Roles",
    label: "Roles",
    url: "/roles",
  },
  {
    icon: MdPeople,
    title: "User Management",
    label: "Users",
    url: "/users",
  },
  // {
  //   title: "Head Teacher",
  //   url: "/head-teacher",
  // },
  // {
  //   title: "District",
  //   url: "/district",
  // },
  {
    icon: RiFolderOpenFill,
    title: "Schools",
    label: "School",
    url: "/schools",
  },
  {
    icon: RiFolderOpenFill,
    title: "Document Assess",
    label: "Doc",
    url: "/document-assessment",
  },
  {
    icon: MdFolderSpecial,
    title: "Applications",
    label: "Applic...",
    url: "/applications",
  },
  {
    icon: MdErrorOutline,
    title: "Claims",
    label: "Claims",
    url: "/",
  },
  {
    icon: MdList,
    title: "List",
    label: "List",
    url: "/applications-list",
  },
  {
    icon: RiFolderOpenFill,
    title: "Document Category",
    label: "Cat",
    url: "/document-category",
  },
  {
    icon: MdList,
    title: "Application Assessment",
    label: "Appl",
    url: "/application-assessment",
  },
];
